import { queryOptions } from '@tanstack/react-query';
import type { SearchOrganizationQuery } from '@repo/api-kit/graphql/types';
import { api as kycbApi } from '@repo/api-kit/kycb';
import { searchOrganization } from '#organizations/queries/search-organization';
import type { ApiGetKybResponse } from './types';

const { ApiGetKybResponse: ApiGetKybResponseFromJSON } = kycbApi.kyb.firstparty.v1;

const all = ['kyb'] as const;

type GraphQLKyb = NonNullable<SearchOrganizationQuery['searchOrganization']['organization']['kyb']>;

/**
 * Transforms GraphQL kyb response to the format expected by ApiGetKybResponse.fromJSON().
 * GraphQL returns uppercase status values (ACCEPTED, PENDING, REFUSED) but the
 * protobuf-generated fromJSON expects lowercase (accepted, pending, refused).
 */
export function adaptGraphQLKybForFromJSON(graphqlKyb: GraphQLKyb): ApiGetKybResponse {
  return ApiGetKybResponseFromJSON.fromJSON({
    ...graphqlKyb,
    kybStatus: graphqlKyb.kybStatus.toLowerCase(),
    flexKybStatus: graphqlKyb.flexKybStatus?.toLowerCase() ?? null,
  });
}

export const kybQueries = {
  all,
  detail: (organizationId: string) =>
    queryOptions({
      queryKey: [...all, organizationId] as const,
      queryFn: async () => {
        const graphqlOrg = await searchOrganization({
          includeFinancialDetail: false,
          organizationId,
        });
        if (!graphqlOrg.kyb) {
          throw new Error('KYB data is missing from organization response');
        }
        return adaptGraphQLKybForFromJSON(graphqlOrg.kyb);
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
